import { createSelector } from '@reduxjs/toolkit';

const selectActiv8BucketById = createSelector(
  (state) => state.activ8.content,
  (_, bucketId) => bucketId,
  (content, bucketId) => content.find((item) => item.bucketId === bucketId) ?? {},
);

export { selectActiv8BucketById };
